import { Field } from "../models/field.model";
export class FormListComponent extends Field {
    constructor() {
        super(...arguments);
        /**
         * @type {string}
         */
        this.STR_validation_message = '';
    }
    /**
     * Function > handleChanged
     * @param {change: string, tag: string, tags: array} MIX_event
     */
    handleChanged(MIX_event) {
        // get form control and set value
        let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
        // set value to form control for correct validation
        OBJ_form_control.setValue(MIX_event.tags);
        // set value to fieldconfig
        this.setValue(MIX_event.tags);
        // mark es dirty and touched
        this.markAsDirtyAndTouched();
        // validate de values
        OBJ_form_control.updateValueAndValidity();
    } // end function handleChanged
    /**
     * Function > handleValidation
     * @param MIX_event
     */
    handleValidation(MIX_event) {
        // get form control
        let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
        if (typeof MIX_event.count !== 'undefined' && this.isRequired()) {
            this.STR_validation_message = '';
            if (MIX_event.count > 0) {
                OBJ_form_control.setErrors(null);
            }
            else {
                OBJ_form_control.setErrors({ required: true });
            } // end if
        }
        else {
            this.STR_validation_message = MIX_event;
        } // end if
    } // end function handleValidation
} // end class FormInputComponent
